import RightArrow from 'src/assets/widget-link-dark@2x.png';

import TwitterLogo from 'src/assets/2021 Twitter logo - white.png';
import FacebookLogo from 'src/assets/f_logo_RGB-White_58.png';
import InstagramLogo from 'src/assets/Instagram_Glyph_White.png';
import YouTubeLogo from 'src/assets/yt_icon_mono_dark.png';
import SheriffImage from 'src/assets/sheriff_undersheriff.jpg';

function LinkList({ title, links, className = '' }) {
  return (
    <div className={`relative pr-2 text-[#cccccc] ${className}`}>
      <div className="uppercase font-semibold tracking-[2px] font-raleway mb-4">{title}</div>
      <ul>
        {links.map(({ name, url }) => (
          <li className="font-lato flex items-center gap-2 mb-2" key={name}>
            <img className="h-8" src={RightArrow} />
            <a href={url} className="no-underline text-sm text-[#cccccc] hover:text-gray-400">
              {name}
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
}

const SocialMediaButtons = [
  {
    icon: <img className="w-5" src={TwitterLogo} />,
    link: 'https://www.youtube.com/channel/UCbk4qQCrbS3DXPxLuHCWg1g',
    transitionColor: 'hover:bg-[#1DA1F2]',
  },
  {
    icon: <img className="w-5" src={FacebookLogo} />,
    link: 'https://www.facebook.com/Utah-County-Sheriffs-Office-465750246852487/',
    transitionColor: 'hover:bg-[#4267B2]',
  },
  {
    icon: <img className="w-5" src={InstagramLogo} />,
    link: 'https://twitter.com/ucso?lang=en',
    transitionColor: 'hover:bg-gradient-to-tr from-yellow-400 via-pink-500 to-purple-500',
  },
  {
    icon: <img className="w-5" src={YouTubeLogo} />,
    link: 'https://www.instagram.com/utahcountysheriff/?hl=en',
    transitionColor: 'hover:bg-[#FF0000]',
  },
];

function SocialMediaButton({ icon, link, transitionColor = '' }) {
  return (
    <a
      href={link}
      className={`rounded-md bg-[#292929] flex items-center justify-center h-10 w-10 cursor-pointer transition-all ${transitionColor}`}
    >
      {icon}
    </a>
  );
}

const Footer = ({ officeStreet, officeCityState, phone, EmEmail }) => {
  return (
    <footer className="bg-[#333333] text-[#cccccc] w-full">
      <div className="flex justify-center">
        <div className="flex flex-col lg:flex-row justify-around p-12 gap-4 items-start">
          <div className="font-lato max-w-lg basis-0 grow text-sm">
            <div className="uppercase font-semibold tracking-[2px] font-raleway text-sm mb-3">
              Contact Us
            </div>
            <div className="mb-3">
              <span className="font-semibold">OFFICE -</span>
              <br />
              3075 North Main
              <br />
              Spanish Fork, Utah 84660
              <br />
            </div>
            <span className="font-semibold">PHONE </span>
            | (801) 851-4000
            <br />
            <span className="font-semibold">FAX </span>
            | (801) 851-4009
            <br />
            <br />
            <span className="font-semibold">EMAIL - PIO Officer </span>|{' '}
            <a
              className="text-white hover:text-gray-200 !no-underline"
              href="mailto:jamesc@utahcounty.gov"
            >
              JamesC@utahcounty.gov
            </a>
            <br />
            <span className="font-semibold font-raleway">EMAIL - GRAMA Requests </span>|{' '}
            <a
              className="text-white hover:text-gray-200 !no-underline"
              href="mailto:sheriffrecords@utahcounty.gov"
            >
              {' '}
              sheriffrecords@utahcounty.gov
            </a>
            <br />
            <br />
            <div className="uppercase font-semibold font-raleway mb-3">Connect With Us</div>
            <div className="flex gap-2">
              {SocialMediaButtons.map((button) => (
                <SocialMediaButton key={button.icon} {...button} />
              ))}
            </div>
            <br />
            <a
              className="font-semibold font-raleway no-underline hover:text-gray-200 text-white"
              href="https://sheriff.utahcounty.gov/information/siteMap"
            >
              SITE MAP
            </a>
            <br />
            <br />
          </div>
          <div className="basis-0 grow max-w-lg flex flex-col lg:flex-row justify-center">
            <LinkList
              className="mb-8 lg:mb-0 w-full lg:w-auto lg:pr-6"
              title="Popular Links"
              links={[
                { name: 'News Releases', url: 'https://sheriff.utahcounty.gov/media/pressArchive' },
                { name: 'Child and Internet Safety', url: 'http://www.missingkids.com/home' },
                { name: 'Employment Opportunities', url: 'https://hr.utahcounty.gov/' },
                { name: 'Report A Crime', url: 'https://sheriff.utahcounty.gov/media/tip' },
                {
                  name: 'Frequently Asked Questions',
                  url: 'https://sheriff.utahcounty.gov/information/faqs',
                },
              ]}
            />
            <LinkList
              className="mb-8 lg:mb-0 w-full lg:w-auto lg:px-6"
              title="Forms"
              links={[
                { name: 'GRAMA Request Link', url: 'https://utah-county-ut.nextrequest.com/' },
              ]}
            />
            <LinkList
              className="mb-8 lg:mb-0 w-full lg:w-auto lg:pl-6"
              title="Codes & Ordinances"
              links={[
                {
                  name: 'Utah County Ordinances',
                  url: 'http://www.utahcounty.gov/ordinances/index.asp',
                },
                { name: 'Utah State Code', url: 'https://le.utah.gov/Documents/code_const.htm' },
              ]}
            />
          </div>
          <div className="flex flex-col grow basis-0 flex-start items-start max-w-lg"></div>
        </div>
      </div>
      <div className="bg-[#292929] flex justify-center p-4">
        <div className="flex flex-wrap flex-col lg:flex-row justify-center gap-6 lg:gap-24 lg:justify-between max-w-5xl">
          <div className="text-gray-500 text-sm text-center lg:text-left">
            Copyrights &copy; 2023 All Rights Reserved By <br />
            Utah County Sheriff&apos;s Ofice <br />
            <a
              className="border-b border-dotted border-gray-500 text-gray-500 hover:text-gray-300 hover:border-gray-300 no-underline hover:border-solid"
              href="http://www.utahcounty.gov/disclaimer.asp"
            >
              Terms of Use
            </a>{' '}
            /{' '}
            <a
              className="border-b border-dotted border-gray-500 text-gray-500 hover:text-gray-300 hover:border-gray-300 no-underline hover:border-solid"
              href="http://www.utahcounty.gov/disclaimer.asp"
            >
              Privacy Policy
            </a>
          </div>
          <div className="flex justify-center">
            <img className="h-[100px]" src={SheriffImage} />
          </div>
          <div className="text-[#158000] flex gap-2 flex-wrap justify-center">
            <a
              href="mailto:sheriffrecords@utahcounty.gov"
              className="text-[#158000] hover:text-white no-underline"
            >
              sheriffrecords@utahcounty.gov
            </a>
            {' | '}
            <a
              href="tel:801-851-4000"
              className="text-[#158000] whitespace-nowrap hover:text-white no-underline"
            >
              801-851-4000
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
